module.exports = __webpack_public_path__ + "pc/img/erCode2.1272987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bottom/erCode2.jpg
// module id = 2ukx
// module chunks = 3